import './index.scss'
import '../../assets/scripts/jquery.mousewheel'

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let contentH = $(document).height(); //内容高度

  if($(window).width() > 1024){
    $('.news-list').css('transform','translateX('+ -scroH +'px)')
    $('.news-contral .progress div').css('width',(scroH/(contentH-viewH))*100 +'%')
    if (contentH == (scroH + viewH)) { 
      $('.news-contral .btn').addClass('back-btn')
    }else{
      $('.news-contral .btn').removeClass('back-btn')
    }
  }
  
});

$('body').mousewheel(function (event,dat) {
  let footerH = $('.fixed-footer').outerHeight()
  if($(window).width() > 1024){
    let scroH = $(document).scrollTop(); //滚动高度
    let viewH = $(window).height(); //可见高度
    let contentH = $(document).height(); //内容高度
    // console.log(contentH,(scroH + viewH + 5))
    if(dat == 1){
      console.log('上翻隐藏footer')
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      setTimeout(function(){
        $('.news-fixed-cont').removeClass('abs')
      },600)
      setTimeout(function(){
        $('body').css({
          "overflow-y": "auto",
          'height':'auto'
        });
      },500)
    }else if(dat == -1 && contentH <= (scroH + viewH + 5)){
      console.log('下翻显示footer')
      if(!$('.fixed-footer').hasClass('show')){
        $('.fixed-footer').addClass('show')
        $('.news-fixed-cont').addClass('abs')
        $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
        
        $('body').css({
          "overflow-y": "hidden",
          'height':'100vh'
        });
      }
    }
  }
})

$('.news-contral .btn').on('click',function(){
  if($(this).hasClass('back-btn')){
    if($('.fixed-footer').hasClass('show')){
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.news-fixed-cont').removeClass('abs')
      setTimeout(function(){
        $(document.body).css({
          "overflow-y": "auto",
          'height':'auto'
        });
      })
      $('html ,body').animate({scrollTop: 0},0);
    }else{
      $('html ,body').animate({scrollTop: 0},'slow');
    }
  }else{
    let scroH = $(document).scrollTop()
    let scrollW = $(window).width() - $(window).width()*0.15;
    $('html ,body').animate({scrollTop: scroH + scrollW},'slow');
  }
})


$(document).ready(function(){
  getH()
})

$(window).resize(function(){
  setTimeout(function(){
    getH()
  },500)
})

function getH(){
  let viewW = $(window).width()
  let viewH = $(window).height()
  let height = $('.news-list').outerWidth() + viewW*0.15 - (viewW - viewH)
  if($(window).width() > 1024){
    $('.zhanwei').css('height',height + 'px');
  }
}